<template>
  <div>
    <navigationBar :fill="true"/>
    <div class="width-1200">
      <breadcrumb/>
    </div>
    <div class="width-1200" style="margin: 40px auto 0;">
      <navStepList2 :current="step"/>
    </div>
    <template v-if="step === 1">
      <div class="width-1200 section1">
        <div class="table-result" style="margin: 0 0 40px;">域名注册清单</div>
        <Table
            ref="registerTable"
            class="bg-color-242631 td-color-303240"
            :columns="columns"
            :data="registerList"
            :loading="registerLoading"
            @on-selection-change="select"
        >
          <!-- 年限选择 -->
          <template slot="year" slot-scope="{ row, index }">
            <Select class="cart-bg-color-3a3c46" transfer-class-name="cart-bg-color-3a3c46" transfer :value="row.count"
                    style="width: 120px" @on-change="itemYearChange($event, index, 0)">
              <Option v-for="item2 in yearList" :key="item2.value" :value="item2.value">{{ item2.label }}</Option>
            </Select>
          </template>
          <!-- 价格显示 -->
          <template slot="price" slot-scope="{ row }">
            <span class="c-o1">{{ row.activityPrice != null ? row.activityPrice : row.price }}<span>元/年</span></span>
            <span>(续费价格:<span
                class="c-o1">{{ row.renewActivityPrice != null ? row.renewActivityPrice : row.renewPrice }}<span>元/年</span></span>)</span>
          </template>
          <!-- 年限显示 -->
          <template slot="total" slot-scope="{ row }">
            <span class="c-o1">{{ row | priceFilter }}</span>
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="{ row, index }">
            <Button class="bg-color-51525B" shape="circle" @click="del(0, row, index)">移除</Button>
          </template>
        </Table>
      </div>
      <div class="width-1200 section1" v-if="renewList.length > 0">
        <div class="table-result">域名续费清单</div>
        <Table
            ref="renewTable"
            class="bg-color-242631"
            :columns="columns2"
            :data="renewList"
            :loading="renewLoading"
            @on-selection-change="select"
        >
          <!-- 年限选择 -->
          <template slot="year" slot-scope="{ row, index }">
            <Select
                class="cart-bg-color-3a3c46" transfer-class-name="cart-bg-color-3a3c46"
                transfer
                :value="row.count"
                style="width: 120px"
                @on-change="itemYearChange($event, index, 1)">
              <Option v-for="item2 in yearList" :key="item2.value" :value="item2.value">{{ item2.label }}</Option>
            </Select>
          </template>
          <!-- 价格显示 -->
          <template slot="price" slot-scope="{ row }">
            <span class="c-o1">{{ row.activityPrice != null ? row.activityPrice : row.price }}<span>元/年</span></span>
          </template>
          <!-- 年限显示 -->
          <template slot="total" slot-scope="{ row }">
            <span class="c-o1">{{ row | priceFilter }}</span>
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="{ row, index }">
            <Button class="bg-color-51525B" shape="circle" @click="del(1, row, index)">移除</Button>
          </template>
        </Table>
      </div>
      <div class="width-1200 section1" v-if="transferList.length > 0">
        <div class="table-result">域名转入清单</div>
        <Table
            ref="transferTable"
            class="bg-color-242631"
            :columns="columns3"
            :data="transferList"
            :loading="transferLoading"
            @on-selection-change="select"
        >
          <!-- 价格显示 -->
          <template slot="price" slot-scope="{ row }">
            <span class="c-o1">{{ row.activityPrice != null ? row.activityPrice : row.price }}<span>元/年</span></span>
          </template>
          <!-- 年限显示 -->
          <template slot="total" slot-scope="{ row }">
            <span class="c-o1">{{ row | priceFilter }}</span>
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="{ row, index }">
            <Button class="bg-color-51525B" shape="circle" @click="del(2, row, index)">移除</Button>
          </template>
        </Table>
      </div>
      <div class="width-1200 section1">
        <div class="table-title">注册局要求，域名购买时必须填写完整的用户信息方可注册。以下为您曾经使用过的域名信息，您可以直接使用：</div>
        <div class="table-sub">使用已实名的信息模板注册域名后不需要再提交实名，可在信息模板中创建和管理。</div>
        <Table
            class="bg-color-242631"
            ref="templateTable"
            :loading="templateLoading"
            :show-header="false"
            :columns="templateColumns"
            :data="templateData"
            @on-select="evt_select"
        >
          <template slot="name" slot-scope="{ row }">
            <span v-if="row.type === 0">{{ row.locName }}(个人)</span>
            <span v-else>{{ row.locBusinessName }}(企业)</span>
          </template>
          <template slot="action" slot-scope="{ row, index }">
            <div style="display: flex; justify-content: space-between">
              <Button shape="circle" @click="viewTemplate(row, index)" :class="[{'C4332E': row._expanded}]">
                {{ row._expanded ? '收起' : '查看' }}
              </Button>
              <Button class="bg-color-51525B" shape="circle" v-if="row.isTemporary === 0"
                      @click="delTemplate(row, index)">删除
              </Button>
            </div>
          </template>
        </Table>
        <div class="page-warrp">
          <Button type="info" to='/user/template/add' ghost>创建新的模板信息</Button>
          <Page
              className="page-css"
              show-total
              :current="templatePage.page"
              :total="templatePage.total"
              :page-size="templatePage.limit"
              show-sizer
              :placement="templatePage.placement"
              :page-size-opts="templatePage.pageSizeOpts"
              @on-change="onChange"
              @on-page-size-change="onPageSizeChange"
          />
        </div>
      </div>
      <div class="width-1200 section1">
        <div class="cart-tool">
          <div class="num">
            <div v-if="registerCount > 0" class="label">注册域名数量：<span class="price-bold">{{ registerCount }}</span>个</div>
            <div v-if="renewCount > 0" class="label">续费域名数量：<span class="price-bold">{{ renewCount }}</span>个</div>
            <div v-if="transferCount > 0" class="label">转入域名数量：<span class="price-bold">{{ transferCount }}</span>个</div>
          </div>
          <div class="x-label">总计：¥<span class="price-bold">{{ totalPrice | priceToRadix }}</span></div>
        </div>
        <div class="cart-agreement">
          <div style="text-align: right;">
            <div class="row">
              <Checkbox class="color-C4332E" v-model="single"> 我已阅读并同意遵守</Checkbox>
              <div style="cursor: pointer; color: #333333; font-size: 16px;" @click="domainNameRegisterRulesModel">
                《智慧康{{domainNameRegisterRulesTitle}}》
              </div>
              <div style="cursor: pointer; color: #333333; font-size: 16px;" @click="privacyStatementRulesModel">
                和《智慧康{{privacyStatementRulesTitle}}》
              </div>
            </div>
            <Button class="buy-btn" @click="event_buy" type="info" ghost>立即购买</Button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="step === 2">
      <div class="width-1200 section1 relative">
        <loading :loading="orderLoading" background="transparent" color="#c4332e" style="z-index: 120"></loading>
        <div class="table-result" style="margin: 0 0 40px;">订单详情</div>
        <Table class="bg-color-242631 td-color-303240" :columns="orderColumns" :data="orderList">
          <template slot="action" slot-scope="{ row }">
            <Button class="bg-color-51525B" shape="circle" @click="act_orderInfo(row)">订单详情</Button>
          </template>
        </Table>
      </div>
      <div class="width-1200 section1 relative">
        <loading :loading="payLoading" background="transparent" color="#c4332e" style="z-index: 120"></loading>
        <div class="table-result" style="margin: 0 0 40px;">请选择支付方式</div>
        <div class="relative pay-tool">
          <div :class="['item-tool item-tool-hide', { active: orderStep === 0 }]" @click="payState(0)">
            <img src="@/assets/image/wechar-icon.png"/>微信支付
            <img class="icon" src="@/assets/image/pay-select-icon.png"/>
          </div>
          <div :class="['item-tool item-tool-hide', { active: orderStep === 1 }]" @click="payState(1)">
            <img src="@/assets/image/ali-icon.png"/>支付宝支付
            <img class="icon" src="@/assets/image/pay-select-icon.png"/>
          </div>
          <div :class="['item-tool item-tool-info', { active: orderStep === 2 }]" @click="payState(2)">
            <div>余额支付：剩余￥{{ balance }}</div>
            <div class="tips" v-if="orderList.length > 0 && balance < orderList[0].payAmount">
              余额已不足支付，<span @click.stop="toRecharge">充值</span>
            </div>
            <img class="icon" src="@/assets/image/pay-select-icon.png"/>
          </div>
        </div>
        <Button class="buy-btn" type="info" ghost @click="evt_pay">立即支付</Button>
        <div class="pay-tips">
          <img class="icon" src="@/assets/image/tips-warn.png"/>
          温馨提示：由于域名的时效性，订单如未及时支付结算，有可能会出现结算失败。为避免造成损失，请及时支付
        </div>
      </div>
    </template>
    <template v-if="step === 3">
      <div class="width-1200 section1">
        <div class="order-success">
          <div class="order-success-icon">
            <img src="@/assets/image/order-success-icon.png"/>
          </div>
          <div class="table-result">恭喜您，已支付成功！</div>
        </div>
        <Table
            class="bg-color-242631 td-color-303240"
            :columns="resColumns"
            :data="resList"
        ></Table>
        <div style="text-align: center;">
          <Button class="buy-btn" type="info" ghost to="/user/domain">我的域名</Button>
        </div>
      </div>
    </template>
    <pay-modal :show.sync="wayModalShow" :codeUrl="wayPayCode"></pay-modal>
    <order-info-modal
        :show.sync="orderInfoModalShow"
        :id="orderId"
    ></order-info-modal>
    <!-- 智慧康域名注册协议 -->
    <rule-modal
        :show.sync="domainNameRegisterRulesModelShow"
        :content="domainNameRegisterRulesContent"
        :title="domainNameRegisterRulesTitle"
    ></rule-modal>
    <!-- 智慧康隐私声明 -->
    <rule-modal
        :show.sync="privacyStatementRulesModelShow"
        :content="privacyStatementRulesContent"
        :title="privacyStatementRulesTitle"
    ></rule-modal>
    <confirmModal :show.sync="deleteTemplateModalVisibility" :isLoading="true" title="移除确认" content="确定要删除此模板吗？"
                  @onConfirm="deleteTemplateModalConfirm"></confirmModal>
    <confirmModal :show.sync="deleteDomainModalVisibility" :isLoading="true" title="移除确认" content="确定要删除此域名吗？"
                  @onConfirm="deleteDomainModalConfirm"></confirmModal>
    <footBar/>
  </div>
</template>
<script>
import navigationBar from "components/navigationBar";
import breadcrumb from "components/breadcrumb";
import navStepList2 from "components/navStepList2";
import smTableExpand from "./components/smTableExpand.vue";
import footBar from "components/footBar.vue";
import loading from "components/loading.vue";
import payModal from "./components/payModal.vue";
import orderInfoModal from "./components/orderInfoModal.vue";
import ruleModal from "components/ruleModal.vue";
// import domainNameRegisterRules from "assets/rule/domainNameRegisterRules";
// import privacyStatement from "assets/rule/privacyStatement";
import confirmModal from "components/commonModal/confirmModal.vue";
import {
  getTemplates,
  getShoppingCart,
  delectShopCart,
  createOrder,
  delectTemplates,
  pay,
  orderCountEdit,
  orderPayOrder,
  agreementList
} from "api/domain.js";
import { mapMutations, mapState,mapActions } from "vuex";
import { WEBSOCKET_URL } from "@/utils/config";
export default {
  components: {
    navigationBar,
    breadcrumb,
    navStepList2,
    footBar,
    loading,
    payModal,
    orderInfoModal,
    ruleModal,
    confirmModal
  },
  filters: {
    priceFilter(val) {
      // 注册价格
      const registerPrice =
          val.activityPrice != null ? val.activityPrice : val.price;
      if (val.type === 0) {
        if (val.count !== 1) {
          // 超过一年使用续费价格
          let renewPrice =
              val.renewActivityPrice != null
                  ? val.renewActivityPrice
                  : val.renewPrice;
          const totalPrice = registerPrice + renewPrice * (val.count - 1);
          return `${totalPrice}元/年`;
        }
        return `${registerPrice}元/年`;
      }
      return `${registerPrice * val.count}元/年`;
    },
    priceToRadix(val) {
      return val.toFixed(2);
    },
  },
  data() {
    return {
      single: false,
      step: 1,
      // 确认订单数据
      yearList: [
        {
          value: 1,
          label: "1年",
        },
        {
          value: 2,
          label: "2年",
        },
        {
          value: 3,
          label: "3年",
        },
        {
          value: 4,
          label: "4年",
        },
        {
          value: 5,
          label: "5年",
        },
        {
          value: 6,
          label: "6年",
        },
        {
          value: 7,
          label: "7年",
        },
        {
          value: 8,
          label: "8年",
        },
        {
          value: 9,
          label: "9年",
        },
        {
          value: 10,
          label: "10年",
        },
      ],
      value: null,
      columns: [
        {
          type: "selection",
          width: 60,
        },
        {
          align: "center",
          title: "域名",
          key: "tradeName",
        },
        {
          slot: "year",
          renderHeader: (h) => {
            let that = this;
            let option = this.yearList.map((o) => {
              return h(
                  "Option",
                  {
                    props: {
                      value: o.value,
                    },
                  },
                  o.label
              );
            });
            let select = h(
                "Select",
                {
                  props: {
                    transfer: true,
                    value: this.value,
                    transferClassName: "cart-bg-color-3a3c46"
                  },
                  class: ['cart-bg-color-3a3c46'],
                  style: {
                    width: "120px",
                  },
                  on: {
                    "on-change"(val) {
                      that.registerList.forEach((element) => {
                        element.count = val;
                      });
                      let ids = that.registerList.map(item => {
                        return item.id;
                      })
                      that.calculateAll(val, ids);
                    },
                  },
                },
                option
            );
            return select;
          },
        },
        {
          align: "center",
          title: "单价",
          slot: "price",
        },
        {
          align: "center",
          title: "小计",
          slot: "total",
        },
        {
          align: "center",
          title: "操作",
          slot: "action",
        },
      ],
      columns2: [
        {
          type: "selection",
          width: 60,
        },
        {
          align: "center",
          title: "域名",
          key: "tradeName",
        },
        {
          slot: "year",
          renderHeader: (h) => {
            let that = this;
            let option = this.yearList.map((o) => {
              return h(
                  "Option",
                  {
                    props: {
                      value: o.value,
                    },
                  },
                  o.label
              );
            });
            let select = h(
                "Select",
                {
                  props: {
                    transfer: true,
                    value: this.value,
                    transferClassName: "cart-bg-color-3a3c46"
                  },
                  class: ['cart-bg-color-3a3c46'],
                  style: {
                    width: "120px",
                  },
                  on: {
                    "on-change"(val) {
                      that.renewList.forEach((element) => {
                        element.count = val;
                      });
                      let ids = that.renewList.map(item => {
                        return item.id;
                      })
                      that.calculateAll(val, ids);
                    },
                  },
                },
                option
            );
            return select;
          },
        },
        {
          align: "center",
          title: "单价",
          slot: "price",
        },
        {
          align: "center",
          title: "小计",
          slot: "total",
        },
        {
          align: "center",
          title: "操作",
          slot: "action",
        },
      ],
      columns3: [
        {
          type: "selection",
          width: 60,
        },
        {
          align: "center",
          title: "域名",
          key: "tradeName",
        },
        {
          align: "center",
          title: "年限",
          key: "count",
        },
        {
          align: "center",
          title: "单价",
          slot: "price",
        },
        {
          align: "center",
          title: "小计",
          slot: "total",
        },
        {
          align: "center",
          title: "操作",
          slot: "action",
        },
      ],
      // 模板分页
      templatePage: {
        page: 1,
        limit: 10,
        total: 0,
        placement: "bottom",
        pageSizeOpts: [10, 20, 30, 40],

      },
      // 模板表格栅格
      templateColumns: [
        {
          type: "expand",
          width: "1",
          render: (h, {row}) => {
            return h(smTableExpand, {
              props: {
                info: row,
              },
            });
          },
        },
        {
          type: "selection",
          width: 60,
        },
        {
          key: "templateName",
          ellipsis: true,
        },
        {
          slot: "name",
          ellipsis: true,
        },
        {
          key: "email",
          width: "200px",
          ellipsis: true,
          render: (h, {row}) => {
            return h("div", row.email || "--");
          },
        },
        {
          key: "status",
          width: "120px",
          align: "center",
          render: (h) => {
            return h("div", "已实名认证");
          },
        },
        {
          slot: "action",
          width: "160px",
        },
      ],
      templateLoading: false,
      // 模板数据
      templateData: [],
      // 域名注册loading
      registerLoading: false,
      // 注册域名数据
      registerList: [],
      // 注册域名数量
      registerCount: 0,
      // 域名续费loading
      renewLoading: false,
      // 续费域名数据
      renewList: [],
      // 续费域名数量
      renewCount: 0,
      // 域名转入loading
      transferLoading: false,
      // 转入域名数据
      transferList: [],
      // 转入域名数量
      transferCount: 0,
      // 总价格
      totalPrice: 0,
      // 支付类型
      orderStep: 2,
      // 支付加载状态
      payLoading: false,
      // 订单表格表头
      orderColumns: [
        {
          title: "订单编号",
          key: "orderNo",
          align: "center",
        },
        {
          title: "订单金额",
          key: "total",
          align: "center",
        },
        {
          title: "应付金额",
          key: "payAmount",
          align: "center",
        },
        {
          title: "下单时间",
          key: "createdTime",
          align: "center",
        },
        {
          title: "操作项",
          slot: "action",
          align: "center",
        },
      ],
      // 二维码链接
      wayPayCode: "",
      // 二维码支付弹窗
      wayModalShow: false,
      // 订单数据
      orderList: [],
      // 结果表格表头
      resColumns: [
        {
          title: "订单编号",
          key: "subOrderNo",
          align: "center",
        },
        {
          title: "域名",
          key: "domainName",
          align: "center",
        },
      ],
      // 结果数据
      resList: [],
      // 订单详情弹窗
      orderInfoModalShow: false,
      // 订单id
      orderId: "",
      // 在线支付加载状态
      orderLoading: false,
      // 域名注册协议
      domainNameRegisterRulesModelShow: false,
      domainNameRegisterRulesContent: "",
      domainNameRegisterRulesTitle: "",
      // 隐私声明
      privacyStatementRulesModelShow: false,
      privacyStatementRulesContent: "",
      privacyStatementRulesTitle: "",
      deleteTemplateModalVisibility: false,
      deleteDomainModalVisibility: false,
    };
  },
  computed: {
    ...mapState(["balance", "token"]),
  },
  mounted() {
    if (!this.token) {
      this.$Message.warning("请登陆后操作！");
      this.$router.push("/login")
      return false;
    }
    if (this.$route.query.id) {
      this.orderId = this.$route.query.id;
      this.getDetail();
    }
    this.getAgreementList()
    this.req_getTemplates();
    this.req_getShoppingCart();
    this.ACT_USER_INFO();
  },
  beforeDestroy() {
    // 销毁定时器
    if (this.webSocket) {
      this.sendMessage("stop");
    }
    this.webSocketResetInterval && clearInterval(this.webSocketResetInterval);
    this.heartInterval && clearInterval(this.heartInterval);
  },
  methods: {
    ...mapActions(["ACT_USER_INFO"]),
    ...mapMutations(["MUT_BALANCE"]),
    // 协议
    domainNameRegisterRulesModel() {
      this.domainNameRegisterRulesModelShow = true;
      // if (!this.domainNameRegisterRulesContent) {
      //   this.domainNameRegisterRulesContent = domainNameRegisterRules.content;
      //   this.domainNameRegisterRulesTitle = domainNameRegisterRules.title;
      // }
    },
    privacyStatementRulesModel() {
      this.privacyStatementRulesModelShow = true;
      // if (!this.privacyStatementRulesContent) {
      //   this.privacyStatementRulesContent = privacyStatement.content;
      //   this.privacyStatementRulesTitle = privacyStatement.title;
      // }
    },
    getAgreementList(){
      agreementList([1,3]).then((res) => {
              const { code, data } = res;
              if(code === 200 && data.length>0){
                this.domainNameRegisterRulesContent = data[0].content
                this.domainNameRegisterRulesTitle = data[0].name
                this.privacyStatementRulesContent = data[1].content
                this.privacyStatementRulesTitle = data[1].name
              }
      });
    },
    // 获取详情
    async getDetail() {
      if (!this.orderId) return;
      this.step = 2;
      this.orderLoading = true;
      const res = await orderPayOrder({
        orderNo: this.orderId,
      });
      if (res.code === 200) {
        this.orderList = res.data.orderList;
      }
      this.orderLoading = false;
    },
    // 获取已实名认证模板
    async req_getTemplates() {
      const params = {
        page: this.templatePage.page,
        limit: this.templatePage.limit,
        templateStatus: 2,
      };
      try {
        this.templateLoading = true;
        const {code, data, result} = await getTemplates(params);
        this.templateLoading = false;
        if (code === 200 && result) {
          const tData = [...data.list] || [];
          this.templateData = tData.map((o) => {
            return {...o, _checked: false, _expanded: false};
          });
          this.templatePage.total = data.total;
        }
      } catch (error) {
        this.templateLoading = false;
        console.log(error);
      }
    },
    // 获取购物车
    async req_getShoppingCart() {
      try {
        this.renewLoading = true;
        this.transferLoading = true;
        this.registerLoading = true;
        const {code, data, result} = await getShoppingCart();
        this.renewLoading = false;
        this.transferLoading = false;
        this.registerLoading = false;
        if (code === 200 && result) {
          this.MUT_BALANCE(data.yue);
          data.shopList.forEach((o) => {
            if (o.type === 0) {
              this.registerList = o.voList.map((o1) => {
                // 注册价格
                const registerPrice =
                    o1.activityPrice != null ? o1.activityPrice : o1.price;
                if (o1.count === 1) {
                  this.totalPrice += registerPrice;
                } else {
                  // 超过一年使用续费价格
                  let renewPrice =
                      o1.renewActivityPrice != null
                          ? o1.renewActivityPrice
                          : o1.renewPrice;
                  this.totalPrice +=
                      registerPrice + renewPrice * (o1.count - 1);
                }
                return {...o1, _checked: true};
              });
              this.registerCount = this.registerList.length;
            } else if (o.type === 1) {
              this.renewList = o.voList.map((o2) => {
                // 总价格
                this.totalPrice +=
                    (o2.activityPrice != null ? o2.activityPrice : o2.price) *
                    o2.count;
                return {...o2, _checked: true};
              });
              this.renewCount = this.renewList.length;
            } else if (o.type === 2) {
              this.transferList = o.voList.map((o2) => {
                // 总价格
                this.totalPrice +=
                    (o2.activityPrice != null ? o2.activityPrice : o2.price) *
                    o2.count;
                return {...o2, _checked: true};
              });
              this.transferCount = this.transferList.length;
            }
          });
        }
      } catch (error) {
        this.renewLoading = false;
        this.transferLoading = false;
        this.registerLoading = false;
        console.log(error);
      }
    },
    async deleteDomainModalConfirm() {
      try {
        // 删除注册域名
        if (this.deleteType === 0) {
          const res = await delectShopCart(this.deleteDomain);
          if (res.code === 200) {
            this.$Message.success("移除成功！");
            this.registerList.splice(this.deleteDomainIndex, 1);
            this.select();
          }
        } else if (this.deleteType === 1) {
          const res = await delectShopCart(this.deleteDomain);
          if (res.code === 200) {
            this.$Message.success("移除成功！");
            this.renewList.splice(this.deleteDomainIndex, 1);
            this.select();
          }
        } else if (this.deleteType === 2) {
          const res = await delectShopCart(this.deleteDomain);
          if (res.code === 200) {
            this.$Message.success("移除成功！");
            this.transferList.splice(this.deleteDomainIndex, 1);
            console.log(this.transferList)
            this.select();
          }
        }
        this.ACT_USER_INFO()
        this.deleteDomainModalVisibility = false;
      } catch (error) {
        this.deleteDomainModalVisibility = false;
        console.log(error);
      }
    },
    // 删除购物车
    del(type, data, index) {
      this.deleteType = type;
      this.deleteDomain = [data.id];
      this.deleteDomainIndex = index;
      this.deleteDomainModalVisibility = true;
    },
    async calculateAll(count, ids) {
      const params = {
        cot: count,
        ids: ids,
      };
      const { code } = await orderCountEdit(params);
      if (code === 200) {
        this.calculate()
      }
    },
    // 计算价格
    calculate() {
      this.totalPrice = 0;
      if (this.$refs.registerTable) {
        this.$refs.registerTable.getSelection().forEach((o) => {
          // 注册价格
          const registerPrice =
              o.activityPrice != null ? o.activityPrice : o.price;
          if (o.count === 1) {
            this.totalPrice += registerPrice;
          } else {
            // 超过一年使用续费价格
            let renewPrice =
                o.renewActivityPrice != null
                    ? o.renewActivityPrice
                    : o.renewPrice;
            this.totalPrice += registerPrice + renewPrice * (o.count - 1);
          }
        });
      }
      if (this.$refs.renewTable) {
        this.$refs.renewTable.getSelection().forEach((o) => {
          this.totalPrice +=
              (o.activityPrice != null ? o.activityPrice : o.price) * o.count;
        });
      }
      if (this.$refs.transferTable) {
        this.$refs.transferTable.getSelection().forEach((o) => {
          this.totalPrice +=
              (o.activityPrice != null ? o.activityPrice : o.price) * o.count;
        });
      }
    },
    // 修改年限
    async itemYearChange(event, index, type) {
      try {
        const params = {
          cot: event,
          ids: [],
        };
        if (type === 0) {
          params.ids = [this.registerList[index].id];
        } else if (type === 1) {
          params.ids = [this.renewList[index].id];
        } else if (type === 2) {
          params.ids = [this.transferList[index].id];
        }
        const {code} = await orderCountEdit(params);
        if (code === 200) {
          if (type === 0) {
            const data = this.registerList[index];
            data.count = event;
          } else if (type === 1) {
            const data = this.renewList[index];
            data.count = event;
          } else if (type === 2) {
            const data = this.transferList[index];
            data.count = event;
          }
          this.calculate();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查看模板
    viewTemplate(data, index) {
      let tData = {...data};
      tData._expanded = !tData._expanded;
      this.$set(this.templateData, index, {...tData});
    },
    async deleteTemplateModalConfirm() {
      try {
        // 删除注册域名
        const res = await delectTemplates(this.deleteTemplateId);
        if (res.code === 200) {
          this.$Message.success("移除成功！");
          this.templateData.splice(this.deleteTemplateIndex, 1);
          this.deleteTemplateModalVisibility = false;
        }
      } catch (error) {
        this.deleteTemplateModalVisibility = false;
        console.log(error);
      }
    },
    // 删除模板
    delTemplate(data, index) {
      this.deleteTemplateId = data.templateId;
      this.deleteTemplateIndex = index;
      this.deleteTemplateModalVisibility = true;
    },
    // 分页
    onChange(current) {
      this.templatePage.page = current;
      this.req_getTemplates();
    },
    // 分页页码
    onPageSizeChange(size) {
      this.templatePage.page = 1;
      this.templatePage.limit = size;
      this.req_getTemplates();
    },
    select() {
      if (this.$refs.registerTable) {
        this.registerCount = this.$refs.registerTable.getSelection().length;
      }
      if (this.$refs.renewTable) {
        this.renewCount = this.$refs.renewTable.getSelection().length;
      }
      if (this.$refs.transferTable) {
        this.transferCount = this.$refs.transferTable.getSelection().length;
      }
      this.calculate();
    },
    // 下单
    async event_buy() {
      if (!this.single) {
        this.$Message.warning("请阅读智慧康域名注册协议，智慧康隐私声明！");
        return false;
      }
      try {
        let registerSelect = [], renewSelect = [], transferSelect = [];
        if (this.$refs.registerTable) {
          registerSelect = this.$refs.registerTable.getSelection() || [];
        }
        if (this.$refs.renewTable) {
          renewSelect = this.$refs.renewTable.getSelection() || [];
        }
        if (this.$refs.transferTable) {
          transferSelect = this.$refs.transferTable.getSelection() || [];
        }
        const list = [...registerSelect, ...renewSelect, ...transferSelect];
        if (list.length === 0) {
          this.$Message.warning("请选择域名！");
          return false;
        }
        const templateTable = this.templateData.filter((o) => o._checked);
        if (templateTable.length === 0 && (registerSelect.length > 0 || transferSelect.length > 0)) {
          this.$Message.warning("请选择模板！");
          return false;
        }
        const params = {
          ids: list.map((o) => o.id),
          temp: templateTable.length > 0 ? templateTable[0].id : null,
        };
        const {code, data} = await createOrder(params);
        if (code === 200) {
          this.MUT_BALANCE(data.account);
          this.orderList = data.orderList;
          this.step = 2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 选择模板
    evt_select(selection, row) {
      this.templateData.forEach((o) => {
        o._checked = false;
        if (o.id === row.id) {
          o._checked = true;
        }
      });
    },
    // 选择支付方式
    payState(type) {
      if (type !== 2) {
        return this.$Message.warning("在线充值功能正在建设中");
      }
      this.orderStep = type;
    },
    async evt_pay() {
      this.payLoading = true;
      try {
        const params = {
          outTradeNo: this.orderList[0].orderNo,
          type: this.orderStep,
          source: 0,
        };
        const {code, data, message} = await pay(params);
        if (code === 200) {
          if (!this.webSocket) {
            this.startSocket();
          }
          if (this.orderStep === 0) {
            this.wayPayCode = data;
            this.wayModalShow = true;
          } else if (this.orderStep === 1) {
            this.wayPayCode = data;
            this.wayModalShow = true;
          }
          this.payLoading = false;
        } else {
          this.$Message.warning(message);
        }
      } catch (error) {
        this.payLoading = false;
        console.log(error);
      }
    },
    // webScoket发送消息
    sendMessage(txt) {
      this.webSocket && this.webSocket.send(txt);
    },
    // webScoket异常重连
    resetConnect() {
      this.connectCount = this.connectCount || 0;
      if (!this.webSocketInterval) {
        this.webSocketResetInterval = setInterval(() => {
          this.connectCount += 1;
          if (this.connectCount <= 5) {
            this.startSocket();
            this.webSocketResetInterval &&
            clearInterval(this.webSocketResetInterval);
          }
        }, 1000);
      }
    },
    startSocket() {
      this.messageTotal = 0;
      this.webSocket = new WebSocket(
          `${WEBSOCKET_URL}hkweb/webSocket/domainpay/${this.orderList[0].orderNo}/${this.token}`
      );
      // 接收消息事件
      this.webSocket.onmessage = (e) => {
        if (e.data === "open:suc") {
          this.sendMessage("start");
          this.heartInterval = setInterval(() => {
            if (this.messageTotal === 10) {
              this.sendMessage("heart");
              this.messageTotal = 0;
            }
            this.messageTotal += 1;
          }, 1000);
        }
        if (e.data.includes("msg:")) {
          const message = e.data.split("msg:")[1];
          this.messageTotal = 0;
          const info = JSON.parse(message);
          if (info != null && info.length != null && info.length > 0) {
            if (this.step !== 3) {
              this.step = 3;
            }
            this.resList = info;
            this.sendMessage("stop");
          }
        }
        if (e.data.includes("rec:stop")) {
          this.webSocket.close();
          this.webSocket = "";
          this.heartInterval && clearInterval(this.heartInterval)
        }
      };
    },
    // 订单弹窗
    act_orderInfo(data) {
      this.orderInfoModalShow = true;
      this.orderId = data.orderNo;
    },
  },
};
</script>

<style lang="less" scoped>
.section1 {
  margin-top: 50px;
  padding: 40px 30px;
  border-radius: 25px;
  background-color: #FFFFFF;
  border: 1px solid #E9E9E9;
}

.table-title {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  line-height: 35px;
}

.table-sub {
  font-size: 16px;
  color: #999999;
  line-height: 35px;
  margin-bottom: 20px;
}

.C4332E {
  color: #fff;
  background-color: #C4332E;
}

.page-warrp {
  margin: 50px 0;
  .flex(space-between, center);

}

.cart-tool {
  .flex(space-between, center);
  padding-bottom: 20px;
  border-bottom: 1px solid #E9E9E9;

  .num {
    .label {
      font-size: 24px;
      color: #333333;
    }
  }

  .price-bold {
    color: #C4332E;
    font-size: 24px;
    font-weight: bold;
    padding: 0 8px;
  }

  .x-label {
    font-size: 16px;
    color: #C4332E;
  }
}

.cart-agreement {
  margin-top: 20px;
  .flex(flex-end, center);

  .row {
    display: flex;
    font-size: 16px;
    color: #666666;
  }
}

.buy-btn {
  height: 45px;
  min-width: 120px;
  margin-top: 30px;
  // 主操作按钮：实心蓝底白字
  &.ivu-btn {
    background-color: @brand;
    border-color: @brand;
    color: #fff;
  }
  &.ivu-btn:hover {
    background-color: @brand-hover;
    border-color: @brand-hover;
    color: #fff;
  }
  &.ivu-btn:active {
    background-color: @brand-deep;
    border-color: @brand-deep;
    color: #fff;
  }
}

.pay-tool {
  .flex(flex-start, center);

  .item-tool {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 200px;
    height: 90px;
    border: 1px solid #E2E2E2;
    margin-right: 20px;
    border-radius: 4px;
    user-select: none;
    cursor: pointer;
    color: #333333;
    font-size: 16px;
    background-color: #FFFFFF;
    position: relative;

    img {
      width: 34px;
      height: 30px;
      margin-right: 10px;
    }

    .icon {
      font-size: 0;
      width: 23px;
      height: 22px;
      opacity: 0;
      position: absolute;
      bottom: -1px;
      right: -1px;
      margin-right: 0;
    }
  }

  .item-tool-hide {
    position: relative;
    cursor: no-drop;

    &:before {
      content: "正在开发中";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      color: #fff;
      font-size: 18px;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 4px;
      text-align: center;
      line-height: 88px;
    }
  }

  .item-tool.active {
    border-color: #288DF0;

    .icon {
      opacity: 1;
    }

  }
}

.pay-tips {
  .flex(flex-start, center);
  margin-top: 30px;
  color: #C4332E;
  background-color: #FDF3F2;
  line-height: 40px;
  border-radius: 4px;
  padding: 0 15px;
  font-size: 16px;

  .icon {
    width: 22px;
    height: 20px;
    margin-right: 5px;
  }
}

.order-success {
  .flex(center, center);
  flex-direction: column;
}
</style>
